export function uniqueArray (list: Array, propertyName: string): Array {
  if (!Array.isArray(list)) {
    throw new Error('First parameter should be array!');
  }
  return list.filter((item, index) => list.findIndex(elem => elem[propertyName] === item[propertyName]) === index);
}
